import React, { FC, SVGProps } from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { FaHeart as RawFaHeart } from "react-icons/fa";
import { APP } from "../storage/constants/properties";
import { useAppSelector } from "../storage/hooks";
import { selectApps, selectGames } from "../storage/slicers/appSlice";
import { AppCardType, AppType } from "../storage/types/state_types";
import classes from "../styles/components/card.module.scss";

const FaHeart = RawFaHeart as FC<SVGProps<SVGSVGElement>>;

interface AppCardProps {
    id: string;
    type: AppType;
}

const Card: React.FC<AppCardProps> = ({ id, type }) => {
    const apps_state = useAppSelector(selectApps);
    const games_state = useAppSelector(selectGames);
    const apps = type === APP ? apps_state : games_state;
    const app = apps.find((a: AppCardType) => a.id === id)!;

    return (
        <Col key={app.id} xxl={3} xl={4} lg={4} md={4} sm={6} xs={12} className="gy-3">
            <NavLink to={app.link} className={classes.link}>
                {/* <-- Inner wrapper gets your padding, bg, shadow, etc */}
                <div className={classes.card}>
                    <Row>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={4} xs={4}>
                            <img
                                src={app.icon}
                                alt={type === APP ? "App Icon" : "Game Icon"}
                                className={classes.icon}
                            />
                        </Col>
                        <Col xxl={7} xl={7} lg={7} md={7} sm={8} xs={8}>
                            <h2 className={classes.title}>{app.title}</h2>
                            <p className={classes.description}>{app.description}</p>
                        </Col>
                    </Row>
                    <div className={classes.favorites}>
                        <FaHeart className={classes.heart} />
                        <p className={classes.likes}>{app.likes}</p>
                    </div>
                </div>
            </NavLink>
        </Col>
    );
};

export default Card;
